import { useTranslation } from "react-i18next";
import BaseButton from "../common/baseButton";
import { useNavigate } from "react-router-dom";

const HomePageOrderFooter = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="hp-order-summary-footer">
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "172px 135px",
                    alignItems: "flex-end",
                }}
            >
                <div>
                    <div style={{ display: "flex", gap: "7px", alignItems: "baseline" }}>
                        <div className="hp-with-subsidies-point"></div>
                        {t("homepage.WithSubsidies")}
                    </div>
                    <div
                        style={{
                            display: "flex",
                            gap: "7px",
                            alignItems: "baseline",
                            paddingTop: 5,
                        }}
                    >
                        <div className="hp-without-subsidies-point"></div>
                        {t("homepage.WithoutSubsidies")}
                    </div>
                </div>
                <div style={{ display: "flex", gap: "7px", alignItems: "baseline" }}>
                    <div className="hp-total-orders-point"></div>
                    {t("homepage.TotalOrders")}
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                <BaseButton onClick={() => navigate("/orders")} className="basic-button">
                    {t("homepage.SeeOrders")}
                </BaseButton>
            </div>
        </div>
    );
};

export default HomePageOrderFooter;
